// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1Sgc_","signatureButtonsRight":"ModalSign_signatureButtonsRight__1Lr_E"};